import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default class AboutTextAnimations {
  constructor() {
    gsap.registerPlugin(ScrollTrigger);
    this.init();
  }

  init() {
    this.setupScrollAnimations();
  }

  setupScrollAnimations() {
    // Get all about big text lines
    const textElements = gsap.utils.toArray('.about-big-line');

    if (textElements.length === 0) return;

    // Animate each text line when scrolling with more precise triggers
    textElements.forEach((text, index) => {
      gsap.to(text, {
        backgroundSize: '100%',
        ease: 'none',
        scrollTrigger: {
          trigger: text,
          start: 'top 95%', // More sensitive - start earlier when top of text reaches 95% from top
          end: 'bottom 55%', // End slightly earlier when bottom of text reaches 55% from top
          scrub: 1.5, // Flüssigeres Scrolling
          toggleActions: 'play none none reverse', // Only animate forward/backward
        },
      });

      // Separate, more sensitive animation for highlighted words in this line
      const highlightedWords = text.querySelectorAll('.about-highlighted');
      highlightedWords.forEach(word => {
        gsap.to(word, {
          backgroundSize: '100%',
          ease: 'none',
          scrollTrigger: {
            trigger: word,
            start: 'top 98%', // Start early
            end: 'top 70%', // End much earlier for faster completion
            scrub: 1.2, // Back to original scrub value
            toggleActions: 'play none none reverse',
          }
        });
      });
    });
  }

  // Method to refresh animations
  refresh() {
    ScrollTrigger.refresh();
  }

  // Cleanup method
  destroy() {
    ScrollTrigger.getAll().forEach(trigger => {
      if (trigger.vars.trigger && trigger.vars.trigger.classList.contains('about-big-line')) {
        trigger.kill();
      }
    });
  }
}